module.exports = __webpack_public_path__ + "img/2.25a0085c.svg";